@if(_user){
<div class="tw-flex tw-gap-2 tw-items-center">
  <div
    class="tw-flex tw-items-center tw-justify-center tw-w-10 tw-aspect-square tw-rounded-full tw-bg-contain tw-bg-center"
    [ngClass]="{'surface-secondary': !_user.profile?.['picture']}"
    [ngStyle]="{'background-image': _user.profile?.['picture'] ? 'url(' + _user.profile?.['picture'] + ')' : undefined}">
    @if(!(_user.profile?.['picture'])){ {{initials}} }
  </div>
  <div class="tw-flex tw-flex-col tw-whitespace-nowrap">
    <span class="tg-label">{{name}}</span>
    <span class="tg-sm text-muted">{{_user.email}}</span>

  </div>
</div>
} @else if(_agent){
<div class="tw-flex tw-gap-2 tw-items-center">
  <div
    class="tw-flex tw-items-center tw-justify-center tw-w-10 tw-aspect-square tw-rounded-full  tw-bg-contain tw-bg-center surface-secondary">
    {{initials}}
  </div>
  <div class="tw-flex tw-flex-col tw-whitespace-nowrap">
    <span>{{name}}</span>
    <span class="tg-sm text-muted">{{_agent.agentInfo.liveTransfer?.phone}}</span>
  </div>
  @if(!_agent.agentInfo.liveTransfer?.available){<i class="pi pi-ban tw-text-red-500" title="Not Available"></i>}
</div>
}